import { gql } from "graphql-tag";

export const GET_ACCOUNTS = gql`
  query GetAccounts($page: Int, $limit: Int, $sort: AccountSortInput) {
    accounts(page: $page, limit: $limit, sort: $sort) {
      data {
        id
        name
        isActive
        licenseExpiryDate
        licenseStatus
        usersCount
        createdAt
        updatedAt
      }
      total
      page
      limit
    }
  }
`;

export const GET_MY_ACCOUNT = gql`
  query GetMyAccount {
    myAccounts {
      id
      name
      isActive
      maximumNumberOfUsers
      accountModules
      licenseExpiryDate
      accountManagerEmail
      emailAlias
      createdAt
      updatedAt
      deletedAt
      activeUsersCount
    }
  }
`;

export const GET_ACCOUNT_CONFIG = gql`
  query GetAccountConfig {
    getAccountConfig {
      id
      accountId
      partPrintConfig
      assetPrintConfig
      locationPrintConfig
      createdAt
      updatedAt
    }
  }
`;
